import Member from '../entities/Member';

const inviteMember = (member: Member) => ({
  type: 'INVITE_MEMBER',
  member
});

const successInviteMember = (member: Member) => ({
  type: 'SUCCESS_INVITE_MEMBER',
  member
});

const signinMember = (member: Member) => ({
  type: 'SIGNIN_MEMBER',
  member
});

const successSigninMember = (member: Member) => ({
  type: 'SUCCESS_SIGNIN_MEMBER',
  member
});

const resetPasswordEmail = (member: Member) => ({
  type: 'RESET_PASSWORD_EMAIL',
  member
});

const successResetPasswordEmail = () => ({
  type: 'SUCCESS_RESET_PASSWORD_EMAIL'
});

const rememberSigninMember = (member: Member) => ({
  type: 'REMEMBER_SIGNIN_MEMBER',
  member
});

const readMembersAll = () => ({
  type: 'READ_MEMBERS_ALL'
});

const successReadMembersAll = (members: Member[]) => ({
  type: 'SUCCESS_READ_MEMBERS_ALL',
  members
});

const createMember = (member: Member) => ({
  type: 'CREATE_MEMBER',
  member
});

const successCreateMember = (member: Member) => ({
  type: 'SUCCESS_CREATE_MEMBER',
  member
});

const updateMember = (member: Member) => ({
  type: 'UPDATE_MEMBER',
  member
});

const successUpdateMember = (member: Member) => ({
  type: 'SUCCESS_UPDATE_MEMBER',
  member
});

const successUpdateAccount = (member: Member) => ({
  type: 'SUCCESS_UPDATE_ACCOUNT',
  member
});

const destroyMember = (member: Member) => ({
  type: 'DESTROY_MEMBER',
  member
});

const successDestroyMember = (member: Member) => ({
  type: 'SUCCESS_DESTROY_MEMBER',
  member
});

export {
  inviteMember,
  successInviteMember,
  signinMember,
  successSigninMember,
  rememberSigninMember,
  resetPasswordEmail,
  successResetPasswordEmail,
  readMembersAll,
  successReadMembersAll,
  updateMember,
  successUpdateMember,
  successUpdateAccount,
  destroyMember,
  successDestroyMember,
  createMember,
  successCreateMember
};



// WEBPACK FOOTER //
// ./src/actions/member.ts